import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EolHomeComponent } from './components/eol-home/eol-home.component';
import { FaqComponent } from './components/faq/faq.component';
import { LifeBridgeEligibilityComponent } from './components/home/lifebridge/eligibility.component';
import { BaseLoginContainerComponent } from '../../../coverpath-common/angular/components/login-container/base-login-container.component';
import { AccountCenterDetailedViewComponent } from '../../../coverpath-common/angular/components/account-center/detailed-view/account-center-detailed-view.component';
import { AccountCenterResolver } from '../../../coverpath-common/angular/services/account-center/account-center-resolver.service';
import { ApplicationFormComponent } from '../../../coverpath-common/angular/components/application-form/application-form.component';
import { AccountSettingsComponent } from '../../../coverpath-common/angular/components/account-settings/account-settings.component';
import { AuthGuard } from './services/navguard/auth.navguard';
import { InsuredAcknowledgementComponent } from '../../../coverpath-common/angular/components/acknowledgement/acknowledgement.component';
import { Auth0Guard } from '../../../coverpath-common/angular/navguards/Auth0Guard';
import { ApplicationFormGuard } from './services/navguard/application-form.navguard';
import { IndividualApplicationAccessGuard } from '../../../coverpath-common/angular/navguards/IndividualApplicationAccessGuard';
import { PoliciesOverviewComponent } from '../../../coverpath-common/angular/components/account-center/overview/policies-overview.component';
import { AuthenticationResolver } from '../../../coverpath-common/angular/resolvers/authentication/AuthenticationResolver';
import { Auth0CallbackComponent } from '../../../coverpath-common/angular/services/authentication/auth0callback.component';
import { LoadingComponent } from '../../../coverpath-common/angular/components/shared/loading/loading.component';
import { MMDirectLogoutComponent } from './components/logout/mmdirect-logout.component';
import { AMCAuthenticationResolver } from '../../../coverpath-common/angular/resolvers/authentication/AMCAuthenticationResolver';

const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: 'home' },
    { path: 'home', component: EolHomeComponent },
    { path: 'faq', component: FaqComponent},
    {
        path: 'login',
        component: BaseLoginContainerComponent,
        resolve: {authenticationData: AuthenticationResolver},
        canActivate: [Auth0Guard]
    },
    {
        path: 'lifebridge',
        component: LifeBridgeEligibilityComponent
    },
    {
        path: 'account-center',
        component: PoliciesOverviewComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'acknowledgement',
        component: InsuredAcknowledgementComponent,
        resolve: { authenticationData: AuthenticationResolver }
    },
    {
        path: 'account-center-detailed-view',
        component: AccountCenterDetailedViewComponent,
        canActivate: [AuthGuard, IndividualApplicationAccessGuard],
        resolve: {
            actionString: AccountCenterResolver
        }
    },
    {
        path: 'application-form',
        component: ApplicationFormComponent,
        canActivate: [ApplicationFormGuard],
        resolve: { authenticationData: AMCAuthenticationResolver }
    },
    { path: 'settings', component: AccountSettingsComponent, canActivate: [AuthGuard] },
    {
        path: 'auth0callback/:client',
        component: Auth0CallbackComponent,
        resolve: {authenticationData: AuthenticationResolver}
    },
    { path: 'loading', component: LoadingComponent },
    { path: 'logout', component: MMDirectLogoutComponent, canActivate: [AuthGuard] },
    { path: '**', redirectTo: 'home'}
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: false})],
    exports: [RouterModule],
    providers: [AccountCenterResolver]
})
export class AppRoutingModule {}
